import parse, { DOMNode, HTMLReactParserOptions, domToReact } from "html-react-parser";
import { createElement } from "react";
import NextLink from "next/link";
interface HtmlParserProps {
    html: string;
    parseOptions?: HTMLReactParserOptions;
}

const HtmlReactParser = ({ html, parseOptions }: HtmlParserProps) => {
    const defaultOptions: HTMLReactParserOptions = {
        replace: (domNode: DOMNode) => {
            if (domNode && domNode.type === "tag" && domNode.children?.[0]) {
                switch (domNode.name) {
                    case "h1":
                        return createElement(
                            "h2",
                            {},
                            domToReact([domNode.children?.[0] as DOMNode], parseOptions)
                        );
                    case "h4":
                    case "h5":
                        return createElement(
                            "h3",
                            {},
                            domToReact([domNode.children?.[0] as DOMNode], parseOptions)
                        );
                    case "h6":
                        return createElement(
                            "blockquote",
                            {},
                            domToReact([domNode.children?.[0] as DOMNode], parseOptions)
                        );
                    case "a": {
                        const href = domNode.attribs?.href;
                        if (href.includes("http")) {
                            return createElement(
                                "a",
                                { ...domNode.attribs },
                                domToReact([domNode.children?.[0] as DOMNode], parseOptions)
                            );
                        } else {
                            return createElement(
                                NextLink,
                                { href, target: domNode.attribs?.target },
                                domToReact([domNode.children?.[0] as DOMNode], parseOptions)
                            );
                        }
                    }
                }
            }
            return null;
        },
    };

    return <>{parse(html, { ...defaultOptions, ...parseOptions })}</>;
};

export default HtmlReactParser;
